const styles = {
  VISUAL: "visual",
  AUDIO: "audio",
  TACTILE: "tactile",
  PUZZLE: "puzzle",
};
const styleToText = {
  visual: "Vizual",
  audio: "Auditiv",
  tactile: "Tactil",
  puzzle: "Kinestezic",
};
export default Object.freeze({ styles: styles, styleToText: styleToText });
